
import { useStore } from "@/store";
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "NotificationsComp",
  data() {
    return {};
  },
  setup() {
    const store = useStore();
    return {
      notifications: computed(() => store.state.notifications),
    };
  },
});
